var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.isIgnorarCompensadoEnabled()
          ? _c(
              "a",
              {
                key: "ignorarCompensado",
                staticClass: "btn",
                class: _vm.getClass("ignorarCompensado"),
                attrs: { href: "javascript:;" },
                on: {
                  click: function ($event) {
                    return _vm.filterSelected("ignorarCompensado")
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-money" }),
                _vm._v(" Ignorar compensado\n    "),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }